import { useRouter } from 'next/router';
import { useState, useEffect, createContext, useContext } from 'react';
import { getCompanies, useUser, newTeam } from './useUser';

export const CompanyContext = createContext();

export const CompanyContextProvider = (props) => {
  const { user, team, userFinderLoaded, signOut } = useUser();
  const [userCompanyDetails, setUserCompanyDetails] = useState(null);
  const [creatingTeam, setCreatingTeam] = useState(false);
  const router = useRouter();
  let value;

  useEffect(() => {
    if (userFinderLoaded && getCompanies && user && userCompanyDetails === null) {
      getCompanies(user?.id).then(results => {
        setUserCompanyDetails(Array.isArray(results) ? results : [results])
      });
    }
  });

  if(userCompanyDetails !== null && userCompanyDetails?.length === 0 && !router?.asPath?.includes('add-company') && router?.pathname !== '/dashboard/create-team'){
    if (router?.pathname === '/dashboard/setup/shopify-instructions') {
      value = { activeCompany: null, userCompanyDetails };
      return <CompanyContext.Provider value={value} {...props} />;
    }

    if(team === 'none' && !userCompanyDetails?.team_id && creatingTeam === false){
      setCreatingTeam(true);
      newTeam(user, {"team_name": "My team"}).then((result) => {
        router.replace('/dashboard/setup/integration-selection');
      });
    }

    if(userCompanyDetails?.length > 0 && router?.asPath === '/dashboard'){
      userCompanyDetails?.filter(company=>company?.active_company === true)?.length > 0 ?
          router.replace('/dashboard/'+userCompanyDetails?.filter(company=>company?.active_company === true)[0].company_id+'')
          :
          router.replace('/dashboard/'+userCompanyDetails[0].company_id+'')
    }

    if(team?.team_id &&
        !router?.asPath?.includes('/dashboard/setup/integration-selection') &&
        !router?.asPath?.includes('/dashboard/setup/help-choose-integration')){
      router.replace('/dashboard/setup/integration-selection');
    }
  }

  let activeCompany = router?.query?.companyId ? userCompanyDetails?.filter(company => company?.company_id === router?.query?.companyId) : userCompanyDetails?.filter(company => company?.active_company === true)?.length > 0 ? userCompanyDetails?.filter(company => company?.active_company === true) : Array.isArray(userCompanyDetails) ? userCompanyDetails[0] : userCompanyDetails;
  if(Array.isArray(activeCompany)){
    activeCompany = activeCompany[0]
  }

  value = {
    activeCompany,
    userCompanyDetails
  };

  return <CompanyContext.Provider value={value} {...props}  />;
}

export const useCompany = () => {
  const context = useContext(CompanyContext);
  if (context === undefined) {
    throw new Error(`useUser must be used within a CompanyContextProvider.`);
  }
  return context;
};
